import { flatTranslations } from "@cdv/jazz-i18n";
import { InitOptions } from "i18next";
import cs from "./cs/translation.json" with { type: "json" };
import editor from "@cdv/jazz-editor/cs.json" with { type: "json" };

export const i18nOptions: InitOptions = {
  lng: "cs",
  resources: {
    cs: {
      translation: { ...flatTranslations(cs), ...flatTranslations(editor) },
    },
  },
};
